import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { Page } from 'src/app/shared/models/page';
import { Observable, from } from 'rxjs';
import { PagedData } from 'src/app/shared/models/paged-data';

import { HttpParams } from '@angular/common/http';
import { PageParams } from 'src/app/shared/common/Enums';
import { catchError, map, tap } from 'rxjs/operators';
import { ApiUrlConstants } from 'src/app/shared/common/ApiUrlConstants';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  constructor(
    private webApiService: WebApiService,
    private snack: MatSnackBar
  ) {}



   createAndGetInvoiceDetails(poId: number, userId: number,rfqId: number,quoteId: number,buyerId: number) {
     return this.webApiService.postRequest<any>(
       ApiUrlConstants.createAndGetInvoiceDetails,
       { poId, userId ,rfqId,quoteId,buyerId}
     );
   }

   sendInvoice(reqBody: any){
    console.log('reqBody in sendInvoice', reqBody);
      return this.webApiService.postRequest<any>(
        ApiUrlConstants.sendInvoice,
        reqBody
      );
   }


   generateCommercialInvoicePdf(params: any): Promise<any> {
        return this.webApiService.postRequest<any>(
          ApiUrlConstants.generateCommercialInvoicePdf,
          params
        );
    }

    generatePackingListPdf(params: any): Promise<any> {
        return this.webApiService.postRequest<any>(
          ApiUrlConstants.generatePackingListPdf,
          params
        );
    }

    generateDeliveryNotePdf(params: any): Promise<any> {
        return this.webApiService.postRequest<any>(
          ApiUrlConstants.generateDeliveryNotePdf,
          params
        );
    }


    fetchInvoiceDataById(invoiceId:number):Promise<any>{
      let apiUrl = `/supplier/fetchInvoiceDetailsByInvoiceId/${invoiceId}`;
      return this.webApiService.getRequest<any>(apiUrl)
    }

    createDispatch(reqBody: any) {
      return this.webApiService.postRequest<any>(
        ApiUrlConstants.createDispatch,
        reqBody
      );
    }

    
    fetchDispatchDetailsByDispatchIdAndInvoiceId(dispatchId:number,invoiceId:number):Promise<any>{
      let apiUrl = `/supplier/fetchDispatchDetailsByDispatchIdAndInvoiceId/${dispatchId}/${invoiceId}`;
      return this.webApiService.getRequest<any>(apiUrl)
    }

    fetchDispatchDetailsByDispatchId(dispatchId:number):Promise<any>{
      let apiUrl = `/buyer/fetchDispatchDetailsByDispatchId/${dispatchId}`;
      return this.webApiService.getRequest<any>(apiUrl)
    }

    confirmOrderReceipt(reqBody: any) {
      return this.webApiService.postRequest<any>(
        ApiUrlConstants.confirmOrderReceipt,
        reqBody
      );
    }

    createSupplierFeedback(reqBody: any) {
      let apiUrl = `/buyer/createSupplierFeedback`;
      return this.webApiService.postRequest<any>(
        apiUrl,
        reqBody
      );
    }

    udateSupplierFeedback(feedbackId:number, reqBody: any) {
      let apiUrl = `/buyer/udateSupplierFeedback/${feedbackId}`;
      return this.webApiService.putRequest<any>(
        apiUrl,
        reqBody
      );
    }


    fetchConfirmReceiptDetailsByReceiptId(reqBody: any) {
      let apiUrl = `/buyer/fetchConfirmReceiptDetailsByReceiptId`;
      return this.webApiService.postRequest<any>(
        apiUrl,
        reqBody
      );
    }


    generateInvoicePdf(poId: number, userId: number,rfqId: number,quoteId: number,buyerId: number, docType:string) {
      let apiUrl =  '/supplier/generateInvoicePdf'

      return this.webApiService.postRequest<any>(
        apiUrl,
        { poId, userId ,rfqId,quoteId,buyerId,docType}
      );
    }

    async fetchInvoiceAttachmentExcelData(poId: number, userId: number,rfqId: number,quoteId: number,buyerId: number, docType:string) {
      let apiUrl =  '/supplier/fetchInvoiceAttachmentExcelData'

      return this.webApiService.postRequest<any>(
        apiUrl,
        { poId, userId ,rfqId,quoteId,buyerId,docType}
      );
    }
    

   
}
